export enum FeatureLimiterResult {
	CLOSE_TO_LIMIT = 'CLOSE_TO_LIMIT',
	EXCEEDED_LIMIT = 'EXCEEDED_LIMIT',
	GOOD_TO_USE = 'GOOD_TO_USE'
}